import React from 'react'
// import logo from '../../../assets/images/logo.png'
// import logo from '../../../assets/images/TZORIG5.jpg'
import logo from "../../../assets/images/tirezonelogo.png"

function Logo(width?:any, height?:any) {
  return (
    <div className="logo"><a href="/"><img src={logo} width={width} alt="logo"/></a></div>
  )
}

export default Logo
